import React from "react";
import { useNavigate } from "react-router-dom";
import { Check, Coins, Users } from "lucide-react";
import { Button } from "./ui/button";
import { TIERS, TOPUPS, LEAD_PACKS } from "../lib/pricing";

const PlanCard = ({ t, onSignup }) => (
  <div data-testid={`pricing-plan-${t.key}`} className={`rounded-xl border p-5 flex flex-col bg-white/85 backdrop-blur-md ${t.key === "pro" ? "border-[#A6844A] border-2 shadow-md" : "border-[#E2DCD2]"}`}>
    <div className="flex items-center justify-between">
      <div className="font-semibold text-[#1B3A4B]">{t.name}</div>
      {t.key === "pro" && <span className="text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full bg-[#E7D7B8] text-[#1B3A4B]">Popular</span>}
    </div>
    <div className="font-serif text-3xl font-bold text-[#1C1915] mt-2">{t.price}<span className="text-sm font-sans font-normal text-[#5C564E]">/month</span></div>
    <ul className="mt-3 space-y-1.5 text-sm text-[#5C564E] flex-1">
      <li className="flex items-center gap-1.5"><Coins className="w-3.5 h-3.5 text-[#A6844A]" /> {t.coins} price searches / month</li>
      <li className="flex items-center gap-1.5"><Check className="w-3.5 h-3.5 text-[#2E6B48]" /> {t.perk}</li>
      {t.key === "free" ? (
        <li className="flex items-center gap-1.5"><Check className="w-3.5 h-3.5 text-[#2E6B48]" /> Sample PDF download</li>
      ) : (
        <>
          <li className="flex items-center gap-1.5"><Check className="w-3.5 h-3.5 text-[#2E6B48]" /> Save, send & invoice</li>
          <li className="flex items-center gap-1.5"><Check className="w-3.5 h-3.5 text-[#2E6B48]" /> Price chat (3 coins/reply)</li>
        </>
      )}
    </ul>
    <Button data-testid={`pricing-signup-${t.key}`} onClick={onSignup} className={`mt-4 rounded-full h-10 ${t.key === "pro" ? "bg-[#A6844A] hover:bg-[#8f6f3b]" : "bg-[#1B3A4B] hover:bg-[#132A37]"} text-white`}>
      {t.key === "free" ? "Start free" : `Get ${t.name}`}
    </Button>
  </div>
);

const Extras = () => (
  <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-4">
    <div data-testid="pricing-topups" className="rounded-xl border border-[#E2DCD2] bg-white/85 backdrop-blur-md p-5">
      <div className="flex items-center gap-2 font-semibold text-[#1B3A4B]"><Coins className="w-4 h-4 text-[#A6844A]" /> Extra price searches — $0.50 each</div>
      <div className="mt-2 text-sm text-[#5C564E]">{TOPUPS.map((t) => `${t.coins} for ${t.price}`).join(" · ")} — never expire.</div>
    </div>
    <div data-testid="pricing-lead-packs" className="rounded-xl border border-[#E2DCD2] bg-white/85 backdrop-blur-md p-5">
      <div className="flex items-center gap-2 font-semibold text-[#1B3A4B]"><Users className="w-4 h-4 text-[#A6844A]" /> Lead coins — pay as you go</div>
      <div className="mt-2 text-sm text-[#5C564E]">{LEAD_PACKS.map((p) => `${p.label} ${p.price} (${p.sub.split(" · ")[0]})`).join(" · ")}. First lead search free.</div>
    </div>
  </div>
);

export const PricingSection = () => {
  const navigate = useNavigate();
  return (
    <section id="pricing" data-testid="pricing-section" className="mb-10 scroll-mt-24">
      <div className="bg-white/75 backdrop-blur-md border border-[#E2DCD2] rounded-2xl p-6 sm:p-8 shadow-sm">
        <h2 className="font-serif text-3xl sm:text-4xl text-[#1B3A4B]">Simple pricing</h2>
        <p className="mt-1 text-sm sm:text-base text-[#5C564E]">1 coin = 1 price search. Plans refill every month. Cancel anytime.</p>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {TIERS.map((t) => <PlanCard key={t.key} t={t} onSignup={() => navigate("/register")} />)}
        </div>
        <Extras />
      </div>
    </section>
  );
};
